export var RESPONSE_STATUS_CODES;
(function (RESPONSE_STATUS_CODES) {
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["CONTINUE"] = 100] = "CONTINUE";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["PROCESSING"] = 102] = "PROCESSING";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["OK"] = 200] = "OK";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["CREATED"] = 201] = "CREATED";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["ACCEPTED"] = 202] = "ACCEPTED";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["NO_CONTENT"] = 204] = "NO_CONTENT";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["FORBIDDEN"] = 403] = "FORBIDDEN";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["NOT_FOUND"] = 404] = "NOT_FOUND";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["I_AM_TEAPOT"] = 418] = "I_AM_TEAPOT";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    RESPONSE_STATUS_CODES[RESPONSE_STATUS_CODES["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
})(RESPONSE_STATUS_CODES || (RESPONSE_STATUS_CODES = {}));
